"use client";

import Link from "next/link";

export function Footer() {
  return (
    <footer className="mt-auto bg-background py-6">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          {/* Left side - Copyright */}
          <div className="font-mono text-xs text-foreground">
            ApartmentDibs, LLC © 2025 All Rights Reserved
          </div>

          {/* Right side - Links */}
          <div className="flex items-center gap-4 text-xs font-medium">
            {/* Privacy Policy Link */}
            <Link
              href="https://www.apartmentdibs.com/legal/privacy-policy"
              target="_blank"
              rel="noopener"
              className="font-xs font-medium text-foreground underline-offset-1 hover:underline"
            >
              Privacy Policy
            </Link>

            {/* Terms of Service Link */}
            <Link
              href="https://www.apartmentdibs.com/legal/terms-and-conditions"
              target="_blank"
              rel="noopener"
              className="font-xs font-medium text-foreground underline-offset-1 hover:underline"
            >
              Terms &amp; Conditions
            </Link>

            {/* Social Media Links */}
            <Link
              href="https://x.com/ApartmentDibs"
              target="_blank"
              rel="noopener "
              className="font-xs font-medium text-foreground underline-offset-1 hover:underline"
              aria-label="Follow us on X/Twitter"
            >
              X/Twitter
            </Link>

            <Link
              href="https://instagram.com/apartmentdibs"
              target="_blank"
              rel="noopener"
              className="font-xs font-medium text-foreground underline-offset-1 hover:underline"
              aria-label="Follow us on Instagram"
            >
              Instagram
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
